import React from 'react';
import { observer } from 'mobx-react';
import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';
import { PriceBreakdown } from 'apps/shared';
import { clientStore } from 'apps/client/app';

interface PriceBreakdownProps {
  quote: ShipmentQuoteAppT;
}
export const QuotePagePriceBreakdown = observer(
  ({ quote }: PriceBreakdownProps) => {
    if (!quote) return null;
    const isIntermediatorMode = clientStore.currentPortal === 'INTERMEDIATOR';
    let takeRate = null;
    let takeRateAmount = 0;
    let productionCosts = quote.customerProductionCosts;
    if (isIntermediatorMode) {
      ({ takeRate, productionCosts, takeRateAmount } = quote);
    }

    return (
      <PriceBreakdown
        currency={quote.productQuoteCurrency}
        productionCosts={productionCosts}
        shippingCosts={quote.shippingQuote.cost}
        shippingDiscount={quote.shippingQuote.discount}
        miscItemsTotalCost={quote.miscItemsTotalCost}
        takeRate={takeRate}
        takeRateAmount={takeRateAmount}
        totalCost={quote.totalCost}
      />
    );
  },
);
